import type { IFilter } from '@models/Filter'

import { apiClient } from '../../../gateways/api'
import type {
  ContractinstellingenSearch,
  ContractinstellingenSearchFilters,
} from '../types/ContractinstellingenSearch'

export const fetchTemplates = async (
  filters: ContractinstellingenSearchFilters,
) => {
  const { data } = await apiClient<ContractinstellingenSearch['data']>({
    url: '/rest/template/search',
    method: 'POST',
    data: {
      filters: createFilters(filters),
      skip: 0,
      limit: 1000,
    },
  })

  return data
}

export const initialState: ContractinstellingenSearch = {
  data: { bijlageTemplates: [], activiteitTemplates: [] },
  query: {
    filters: {
      combi: null,
    },
  },
}

export const createFilters = ({ combi }: ContractinstellingenSearchFilters) => {
  const filters: IFilter[] = [
    { name: 'projectType', value: 'Aanvraag', operator: 'eq' },
  ]

  if (combi)
    filters.push({
      name: 'combi',
      value: combi,
      operator: 'eq',
    })

  return filters
}
